import React, { useContext, useState } from 'react';

import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { Button, CircularProgress } from '@mui/material';

const RestoreCompanyModal = ({ modalDetails }) => {
    const modalCtx = useContext(ModalContext);
    const authCtx = useContext(AuthContext);

    const [isRestoring, setIsRestoring] = useState(false);

    const closeHandle = () => {
        modalCtx.closeModal();
    };

    const restoreCompany = async () => {
        setIsRestoring(true);
        try {
            // 1. Restore the company
            const restoreRes = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${modalDetails.id}/restore`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${authCtx.token}` }
            });
            const restoreData = await restoreRes.json();
            if (restoreData.status !== 'success') throw new Error('Restore failed');
        
            // 2. Set status to draft
            const statusRes = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${modalDetails.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authCtx.token}`
                },
                body: JSON.stringify({ status: 'draft' })
            });
            const statusData = await statusRes.json();
            if (statusData.status !== 'success') throw new Error('Status update failed');
        
            // 3. Close modal and trigger reload
            modalCtx.closeModal();
            modalCtx.setPageUpdate({ page: 'Companies', companyId: modalDetails.id });
            } catch (err) {
                console.error('Error restoring company:', err);
            }
            setIsRestoring(false);
    };

    return (
        <>
        <div className="modal-container">
            <div className='modal-header'>
            <span className='modal-header__company-name'>{modalDetails.companyDetails.company}</span>
            </div>
            <div className="modal-body">
            <span>Are you sure you want to restore this company?</span><br />
            <span style={{ fontSize: '12px', color: '#555' }}>Restoring will add this company back as a <b>draft</b>. You can edit and activate it after restoring.</span>
            </div>
            <div className="modal-footer">
            <Button className="cancel-btn" onClick={closeHandle} disabled={isRestoring}>CANCEL</Button>
            <Button onClick={restoreCompany} disabled={isRestoring} color="primary" variant="contained">
                {isRestoring ? <CircularProgress size={16} style={{ color: '#fff' }} /> : ''} RESTORE
            </Button>
            </div>
        </div>
        </>
    );
};

export default RestoreCompanyModal;
